export default {"src":"/_next/static/media/icon3.20974b69.svg","height":512,"width":512};